module.exports = __webpack_public_path__ + "img/collaborate_influencer_image.6fa7fb1b.png";